import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const DEFAULT = { primary_color: "#334155", logo_url: null };

function hexToHsl(hex) {
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.substr(0, 2), 16) / 255;
  const g = parseInt(h.substr(2, 2), 16) / 255;
  const b = parseInt(h.substr(4, 2), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hh, s, l = (max + min) / 2;
  if (max === min) { hh = 0; s = 0; }
  else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hh = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hh = (b - r) / d + 2; break;
      default: hh = (r - g) / d + 4;
    }
    hh /= 6;
  }
  return `${Math.round(hh * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function applyTheme(color) {
  const root = document.documentElement;
  root.style.setProperty("--brand", color);
  try {
    const hsl = hexToHsl(color);
    root.style.setProperty("--primary", hsl);
    root.style.setProperty("--ring", hsl);
  } catch (e) { /* ignore invalid color */ }
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT);

  const load = useCallback(
    () => api.get("/settings").then((r) => {
      setSettings(r.data);
      applyTheme(r.data.primary_color || "#334155");
    }).catch(() => {}),
    []
  );

  useEffect(() => { load(); }, [load]);

  const logoSrc = settings.logo_url ? `${BACKEND}${settings.logo_url}` : null;

  return (
    <SettingsContext.Provider value={{ settings, logoSrc, reload: load, applyTheme }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
